import { useReducedMotion } from 'framer-motion';

/** prefers-reduced-motion, as a plain boolean (framer returns null before hydration). */
export function useReducedMotionPref(): boolean {
  return useReducedMotion() ?? false;
}
